import { Locales } from 'intlayer'

type UserPreferenceTheme = 'light' | 'dark' | 'system'
type UserPreferenceLocale = typeof Locales.ENGLISH | typeof Locales.PORTUGUESE_BRAZIL
type UserPreferenceDateFormat = 'dd/MM/yyyy' | 'MM/dd/yyyy' | 'yyyy-MM-dd' | 'dd.MM.yyyy'
type UserPreferenceTimeFormat = 12 | 24

type UserPreferences = {
	theme: UserPreferenceTheme
	locale: UserPreferenceLocale
	dateFormat: UserPreferenceDateFormat
	timeFormat: UserPreferenceTimeFormat
	weekStartsOnMonday: boolean
	timezone: string
	timezoneAutoSync: boolean
}

type UserPreferencesUpdate = Partial<UserPreferences>

type UserPreferencesPort = {
	get(): Promise<UserPreferences>
	update(patch: UserPreferencesUpdate): Promise<UserPreferences>
}

const defaultUserPreferences: UserPreferences = {
	theme: 'system',
	locale: Locales.PORTUGUESE_BRAZIL,
	dateFormat: 'dd/MM/yyyy',
	timeFormat: 24,
	weekStartsOnMonday: true,
	timezone: 'UTC',
	timezoneAutoSync: true,
}

export type {
	UserPreferenceTheme,
	UserPreferenceLocale,
	UserPreferenceDateFormat,
	UserPreferenceTimeFormat,
	UserPreferences,
	UserPreferencesUpdate,
	UserPreferencesPort,
}
export { defaultUserPreferences }
